import type { StackProps, TextFieldProps } from '@mui/material'
import { Stack } from '@mui/material'
import React from 'react'

import { IntegerTextFieldController } from '@/components/inputs/IntegerTextFieldController'
import { ConfigField } from '@/features/controller/configuration/components/drawers/ConfigField'
import { CONFIG_FIELD_NUMBER_LONG_SX } from '@/features/controller/configuration/constants'

type IntegerConfigFieldProps = Omit<StackProps, 'flexDirection' | 'gap'> & {
  helpTooltip?: string
  label: string
  missingValue?: number
  name: string
  textFieldProps?: Omit<TextFieldProps, 'render' | 'name' | 'helperText'>
  unit?: string
}

export function IntegerConfigField({
  helpTooltip,
  label,
  missingValue,
  name,
  textFieldProps,
  unit,
  ...stackProps
}: Readonly<IntegerConfigFieldProps>) {
  return (
    <ConfigField {...stackProps} helpTooltip={helpTooltip} label={label}>
      <Stack alignItems="center" flexDirection="row" gap={1}>
        <IntegerTextFieldController
          missingValue={missingValue}
          name={name}
          textFieldProps={{
            sx: CONFIG_FIELD_NUMBER_LONG_SX,
            type: 'number',
            ...textFieldProps,
          }}
        />
        {unit}
      </Stack>
    </ConfigField>
  )
}
